<template>
  <div class="privacy-policy">
    <!-- 顶部导航栏 -->
    <header class="policy-header">
      <button class="back-btn" @click="handleBack">
        <span class="icon-arrow-left"></span>
      </button>
      <h1 class="policy-title">隐私政策</h1>
    </header>

    <!-- 主要内容区域 -->
    <main class="policy-content" id="privacyContent">
      <!-- 一、特别提示 -->
      <section class="policy-section">
        <h2 class="section-title">一、特别提示</h2>
        <div class="section-content">
          <!-- 【新增】发布与生效日期 -->
          <!-- <p class="date-info">
            <strong>发布日期：</strong>2026年03月22日<br/>
            <strong>生效日期：</strong>2028年03月22日
          </p> -->
          <p class="mt-2">
            <strong>运营方/研发方名称：</strong>合肥千手医疗科技有限责任公司
          </p>
          <p>
            <strong>联系地址：</strong
            >安徽省合肥市蜀山区黄山路602号合肥国家大学科技园A201
          </p>
          <p class="mt-2">
            我们严格遵守《中华人民共和国个人信息保护法》《医疗数据安全指南》《互联网信息服务深度合成管理规定》《APP违法违规收集使用个人信息行为认定方法》等相关法律法规及行业标准，秉持
            “合法、正当、必要、诚信”
            原则，切实保护您的个人信息与隐私安全。本政策将明确告知您在使用本
            APP（以下简称
            “产品”）过程中，我们收集、使用、存储、共享个人信息的规则，以及您享有的相关权利，请您仔细阅读并理解。使用本产品即视为您同意本隐私政策的全部内容，若您不同意，请立即停止使用本产品。
          </p>
        </div>
      </section>

      <!-- 二、我们如何收集和使用您的个人信息 -->
      <section class="policy-section">
        <h2 class="section-title">二、我们如何收集和使用您的个人信息</h2>

        <!-- 2.1 必要信息收集 (可折叠) -->
        <div class="collapsible-section">
          <div
            class="subsection-title collapsible-header"
            @click="toggleCollapse('necessary')"
          >
            <span>（一）必要信息收集（不提供则无法使用核心功能）</span>
            <span class="arrow-icon" :class="{ up: collapseState.necessary }"
              >↓</span
            >
          </div>
          <div class="collapsible-content" v-show="collapseState.necessary">
            <div class="info-item">
              <div class="info-label">1. 账号与身份信息</div>
              <div class="info-desc">
                注册登录时，您需提供手机号码进行登录（用于匹配检测主体、身份核验及后续服务通知），我们将对您的手机号码进行加密存储，不会泄露给无关第三方。
              </div>
            </div>
            <div class="info-item">
              <div class="info-label">2. 医疗核心数据</div>
              <div class="info-desc">
                为实现 AI 诊断功能，需收集您主动上传的皮肤病变影像（拍照或连接
                4K
                显微镜采集）、病变部位描述、既往病史等信息。此类信息属于敏感医疗数据，仅用于
                AI
                算法分析、诊断报告生成，不用于其他任何用途，且将采取特殊加密措施进行保护。
              </div>
            </div>
            <div class="info-item">
              <div class="info-label">3. 设备与权限信息</div>
              <div class="info-desc">
                需申请以下系统权限以提供服务，您可随时在设备设置中关闭权限，关闭后相应功能将无法正常使用，但不影响其他基础功能：
              </div>
              <ul class="permission-list">
                <li>
                  <strong>相机权限：</strong
                  >用于拍摄皮肤病变影像，仅在您主动触发拍照/采集操作时启用，不主动后台调用。
                </li>
                <li>
                  <strong>存储权限：</strong
                  >用于保存诊断报告、历史病变影像及相关操作记录，便于您后续查看、复用，不访问、读取您设备内的其他无关文件。
                </li>
                <li>
                  <strong>网络权限：</strong
                  >用于将您的相关数据（病变影像、病史信息等）安全传输至 AI
                  诊断服务器，实现算法分析与报告生成，全程采用加密传输方式。
                </li>
              </ul>
            </div>
            <div class="info-item">
              <div class="info-label">4. 设备与系统信息（含传感器数据）</div>
              <div class="info-desc">
                为实现设备识别、安全验证及功能优化，需收集以下设备相关信息：
                <ul class="permission-list">
                  <li>
                    <strong>设备唯一标识（OAID）</strong
                    >：用于设备身份识别、防刷机制、个性化推荐（若有），不会与您的手机号、姓名等个人身份信息关联存储，确保无法通过该标识识别具体个人。
                  </li>
                  <li>
                    <strong>传感器信息</strong
                    >：包括但不限于加速度计、陀螺仪、光线传感器等，仅在您主动触发相关功能时调用（如AI诊断中的动作识别辅助），不用于其他任何用途，且不会上传至服务器。
                  </li>
                  <li>
                    <strong>设备型号、操作系统版本、网络状态</strong
                    >：用于适配不同设备、优化用户体验、排查技术故障，不涉及敏感信息采集。
                  </li>
                </ul>
                所有设备信息均经过脱敏处理，仅在本地临时使用，不长期存储，也不向第三方共享。
              </div>
            </div>
          </div>
        </div>

        <!-- 2.2 非必要信息收集 (可折叠) -->
        <div class="collapsible-section">
          <div
            class="subsection-title collapsible-header"
            @click="toggleCollapse('nonNecessary')"
          >
            <span>（二）非必要信息收集（拒绝不影响基础功能）</span>
            <span class="arrow-icon" :class="{ up: collapseState.nonNecessary }"
              >↓</span
            >
          </div>
          <div class="collapsible-content" v-show="collapseState.nonNecessary">
            <div class="info-item">
              <div class="info-label">1. 位置信息</div>
              <div class="info-desc">
                经您主动授权后收集，仅用于为您推荐附近合作医疗机构（如安徽医科大学第二附属医院），您可随时在APP设置或设备设置中关闭授权，关闭后将不再收集该信息，也不再提供相关推荐服务。
              </div>
            </div>
            <div class="info-item">
              <div class="info-label">2. 使用日志</div>
              <div class="info-desc">
                包括诊断时间、报告查看记录、操作行为记录等，仅用于优化产品体验、完善AI诊断算法、排查系统故障，所有日志数据均已做匿名化处理，去除可识别个人身份的信息，无法关联到具体个人。
              </div>
            </div>
          </div>
        </div>

        <!-- 2.3 信息使用规则 (可折叠) -->
        <div class="collapsible-section">
          <div
            class="subsection-title collapsible-header"
            @click="toggleCollapse('usage')"
          >
            <span>（三）信息使用规则</span>
            <span class="arrow-icon" :class="{ up: collapseState.usage }"
              >↓</span
            >
          </div>
          <div class="collapsible-content" v-show="collapseState.usage">
            <ul class="rule-list">
              <li>
                仅在 “AI 诊断、报告生成、健康管理、权限范围内的服务优化”
                范围内使用您的个人信息，不超出您授权的用途，不擅自扩大使用范围。
              </li>
              <li>
                对用于 AI
                模型训练的数据进行严格的去标识化处理，彻底去除姓名、手机号、设备标识等可识别个人身份的信息，确保处理后的数据无法关联到具体个人，且训练过程全程闭环，不泄露任何原始敏感数据。
              </li>
              <li>
                若因监管要求、法律法规规定或服务升级需要，需扩大信息使用范围，将另行通过弹窗、短信等方式获得您的明确同意，未获得您同意前，绝不扩大使用范围。
              </li>
              <li>
                <strong>补充说明：</strong
                >本产品的AI诊断功能，仅调用第三方官方AI（deepseek、豆包）API接口，我方仅作为API调用方，不开发、不训练、不部署、不运营任何深度合成大模型，不属于《互联网信息服务深度合成管理规定》中定义的“深度合成服务提供者”，相关AI能力的算法备案、安全评估等全部合规要求，由API提供方依法完成并承担主体责任；我方仅负责将您的请求（病变影像、病史等）转发至第三方接口，获取AI诊断结果并展示给您，不会自行存储、训练您的对话及诊断相关数据，也不会对AI生成内容进行二次加工。
              </li>
            </ul>
          </div>
        </div>
      </section>

      <!-- 三、个人信息的共享、转让与公开披露 -->
      <section class="policy-section">
        <h2 class="section-title">三、个人信息的共享、转让与公开披露</h2>
        <div class="section-content">
          <ul class="rule-list">
            <li>
              <strong>共享限制：</strong
              >未经您明确同意，绝不向任何第三方共享您的个人信息（包括敏感医疗数据、身份信息等）。若因服务需要委托第三方处理您的个人信息（如服务器托管、数据加密服务等），我们将严格筛选合作方，签订保密协议，明确其义务与责任，并监督其处理行为，确保您的信息安全。
            </li>
            <li>
              <strong>转让限制：</strong
              >未经您同意，绝不向任何第三方转让您的个人信息；若因公司合并、分立、注销、资产转让等特殊情况需要转让，将提前通过弹窗、短信等方式通知您，获得您的明确同意后方可转让，并确保受让方继续履行本隐私政策约定的义务，否则将承担相应责任。
            </li>
            <li>
              <strong>公开披露：</strong
              >仅在法律、行政法规强制要求，或司法机关、监管机构依法出具相关文书要求时，向相关机构披露必要的个人信息，且会尽最大努力对披露信息进行脱敏处理，保护您的隐私权益，同时将披露情况及时通知您（法律法规禁止通知的除外）。
            </li>
          </ul>
        </div>
      </section>

      <!-- 【新增】第三方 SDK 目录 -->
      <section class="policy-section">
        <h2 class="section-title">四、第三方 SDK 目录</h2>
        <div class="section-content">
          <p class="mb-2">
            为保障 App 相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全评估，以保护您的个人信息安全。以下是我们接入的第三方 SDK 列表：
          </p>
          
          <div class="sdk-block">
            <div class="info-item">
              <div class="info-label">SDK 名称</div>
              <div class="info-desc">移动智能终端补充设备标识体系统一调用 SDK</div>
            </div>
            <div class="info-item">
              <div class="info-label">开发者/公司名称</div>
              <div class="info-desc">中国信息通信研究院</div>
            </div>
            <div class="info-item">
              <div class="info-label">使用目的</div>
              <div class="info-desc">用于唯一标识设备，提供安全稳定的基础服务，保障账号安全，防止恶意程序运行等。</div>
            </div>
            <div class="info-item">
              <div class="info-label">收集个人信息类型</div>
              <div class="info-desc">设备信息（IMEI/MAC/Android ID/IDFA/OAID）</div>
            </div>
            <div class="info-item">
              <div class="info-label">隐私政策链接</div>
              <div class="info-desc">
                <a href="https://www.msa-alliance.cn/col.jsp?id=122" target="_blank" class="sdk-link">
                  https://www.msa-alliance.cn/col.jsp?id=122
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 四、个人信息的存储与安全保护 (原章节序号顺延) -->
      <section class="policy-section">
        <h2 class="section-title">五、个人信息的存储与安全保护</h2>

        <!-- 5.1 存储规范 (原 4.1) -->
        <div class="collapsible-section">
          <div
            class="subsection-title collapsible-header"
            @click="toggleCollapse('specifications')"
          >
            <span>（一）存储规范</span>
            <span
              class="arrow-icon"
              :class="{ up: collapseState.specifications }"
              >↓</span
            >
          </div>
          <div
            class="collapsible-content"
            v-show="collapseState.specifications"
          >
            <div class="info-item">
              <div class="info-label">1. 数据用途</div>
              <div class="info-desc">
                OAID仅用于设备唯一标识、风险控制及个性化推荐（若有），不会与您的手机号、身份证号等个人敏感信息关联存储，确保无法通过OAID识别具体个人。
              </div>
            </div>
            <div class="info-item">
              <div class="info-label">2. 存储方式</div>
              <div class="info-desc">
                采用区块链存证与 AES-256
                加密算法存储所有个人信息及医疗数据，符合《医疗数据安全指南》等行业标准，确保数据存储安全，防止数据被非法访问、篡改、泄露。
              </div>
            </div>
            <div class="info-item">
              <div class="info-label">3. 存储期限</div>
              <div class="info-desc">
                个人身份信息（手机号等）与诊断记录、病变影像等敏感医疗数据，保留至您注销账号后
                30
                天，逾期将通过加密删除、物理销毁等方式彻底清除，无法恢复；匿名化的模型训练数据将长期保留，但该数据已去除所有可识别个人的信息，无法关联到具体个人。
              </div>
            </div>
            <div class="info-item">
              <div class="info-label">4. 跨境限制</div>
              <div class="info-desc">
                不涉及任何跨境数据传输，所有个人信息及医疗数据均存储在我国境内符合法律法规要求的服务器中，严格遵守我国数据跨境传输相关规定。
              </div>
            </div>
            <div class="info-item">
              <div class="info-label">5. 传感器数据处理方式</div>
              <div class="info-desc">
                传感器数据（如加速度计、陀螺仪等）仅在本地设备上进行实时计算与分析，不上传至服务器，不参与任何形式的数据建模或训练，使用完毕后立即清除，不留存痕迹。
              </div>
            </div>
          </div>
        </div>

        <!-- 5.2 安全措施 (原 4.2) -->
        <div class="collapsible-section">
          <div
            class="subsection-title collapsible-header"
            @click="toggleCollapse('precautions')"
          >
            <span>（二）安全措施</span>
            <span class="arrow-icon" :class="{ up: collapseState.precautions }"
              >↓</span
            >
          </div>
          <div class="collapsible-content" v-show="collapseState.precautions">
            <ul class="rule-list">
              <li>
                <strong>访问控制：</strong
                >实施基于角色的权限管理，仅授权的工作人员（如技术运维、客服等）可访问敏感数据，且访问行为将被全程记录操作日志，便于追溯核查。
              </li>
              <li>
                <strong>技术防护：</strong
                >定期开展系统渗透测试、安全审计与漏洞扫描，及时修补系统安全漏洞；采用加密传输、数据脱敏、访问验证等技术手段，全方位保障数据在收集、传输、存储、使用过程中的安全。
              </li>
              <li>
                <strong>应急响应：</strong
                >建立完善的数据安全应急响应机制，若发生数据泄露、篡改、丢失等安全事件，将在
                48 小时内通过短信、APP
                推送等方式通知您，告知事件情况及处置措施，并按照法律法规要求向监管机构报告，同时积极采取补救措施，减少对您的影响。
              </li>
              <li>
                <strong>人员管理：</strong
                >对公司内部工作人员进行个人信息保护培训，明确其保密义务，签订保密协议，对违反保密义务的人员，将依法追究其责任。
              </li>
            </ul>
          </div>
        </div>
      </section>

      <!-- 五、您的个人信息权利 (原章节序号顺延) -->
      <section class="policy-section">
        <h2 class="section-title">六、您的个人信息权利</h2>
        <div class="section-content">
          <p class="mb-2">
            根据《中华人民共和国个人信息保护法》等相关法律法规，您依法享有以下个人信息权利，我们将为您提供便捷的权利行使途径：
          </p>

          <div class="right-item">
            <div class="right-label">1. 查阅与复制权</div>
            <div class="right-desc">
              您可在APP内查看自己的个人信息（手机号、诊断记录、操作日志等），如需复制相关信息，可联系客服申请，我们将在规定时间内提供。
            </div>
          </div>

          <div class="right-item mt-2">
            <div class="right-label">2. 删除与撤回权</div>
            <div class="right-desc">
              您可在APP内申请删除单条诊断记录、病变影像等信息；也可通过客服申请注销账号，账号注销后，所有个人信息（身份信息、诊断记录、影像数据等）将在30天内不可逆删除，删除后无法恢复。您也可随时撤回对各项权限（相机、存储、位置等）的授权，撤回后我们将不再收集相应信息。
            </div>
          </div>

          <div class="right-item mt-2">
            <div class="right-label">3. 更正权</div>
            <div class="right-desc">
              若您发现自己的个人信息（如手机号）存在错误，可联系客服申请更正，我们将核实后及时为您修改。
            </div>
          </div>

          <div class="right-item mt-2">
            <div class="right-label">4. 异议与投诉权</div>
            <div class="right-desc">
              对 AI
              诊断的自动化决策有异议时，可联系客服申请人工复核；若您认为我们的个人信息处理行为违反法律法规或本隐私政策，可向我们投诉，也可向监管机构举报。
            </div>
          </div>

          <div class="contact-info mt-4">
            <p style="margin-bottom: 8px">
              您可拨打客服电话提交上述请求，我们将在 15
              个工作日内反馈处理结果，若情况复杂，可适当延长处理期限，但会提前告知您延长的理由及期限。
            </p>
            <a href="tel:055162614668" class="phone-number"
              >客服电话：0551-62614668</a
            >
          </div>
        </div>
      </section>

      <!-- 六、隐私政策的更新与通知 (原章节序号顺延) -->
      <section class="policy-section">
        <h2 class="section-title">七、隐私政策的更新与通知</h2>
        <div class="section-content">
          <p>
            本隐私政策将根据法律法规更新、产品功能升级、行业标准变化等情况进行修订，修订后将在APP内通过弹窗、通知等方式向您公示，公示期满后生效。若修订内容涉及您的核心权益（如收集、使用个人信息的范围、目的等），我们将另行通过短信等方式通知您，您可自主选择是否接受修订后的隐私政策，若您不接受，可停止使用本产品，继续使用则视为您同意修订后的全部内容。
          </p>
        </div>
      </section>

      <!-- 七、免责说明 (原章节序号顺延) -->
      <section class="policy-section">
        <h2 class="section-title">八、免责说明</h2>
        <div class="section-content">
          <ul class="rule-list">
            <li>
              因不可抗力（如地震、洪水、网络中断等）、第三方恶意攻击等非我方原因导致的个人信息泄露、丢失、篡改，我们不承担责任，但会尽力协助您减少损失。
            </li>
            <li>
              您自愿向第三方披露个人信息（如将诊断报告分享给他人），或因您自身操作失误、保管不当（如泄露账号密码）导致的个人信息安全问题，由您自行承担责任。
            </li>
          </ul>
        </div>
      </section>

      <!-- 八、联系方式 (原章节序号顺延) -->
      <section class="policy-section">
        <h2 class="section-title">九、联系方式</h2>
        <div class="section-content">
          <p>
            若您对本隐私政策有疑问、需要行使个人信息权利，或有投诉、建议，可通过以下方式联系我们：
          </p>
          <div class="info-item mt-2">
            <div class="info-label">运营方/研发方</div>
            <div class="info-desc">合肥千手医疗科技有限责任公司</div>
          </div>
          <div class="info-item">
            <div class="info-label">联系地址</div>
            <div class="info-desc">
              安徽省合肥市蜀山区黄山路602号合肥国家大学科技园A201
            </div>
          </div>
          <div class="info-item">
            <div class="info-label">客服电话</div>
            <div class="info-desc">
              <a href="tel:055162614668" class="phone-number">0551-62614668</a>
            </div>
          </div>
          <p class="mt-2">我们将及时响应您的需求，依法为您提供帮助。</p>
        </div>
      </section>

      <!-- 底部签署信息 -->
      <div class="footer-signature">
        <p>合肥千手医疗科技有限责任公司</p>
        <!-- 【新增】底部日期标识，增强合规性 -->
        <p class="date-info-footer">
          发布日期：2026年03月22日 | 生效日期：2028年03月22日
        </p>
      </div>

      <!-- 底部留白 -->
      <div class="bottom-space"></div>
    </main>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      // 折叠状态管理，默认只有“必要信息”是展开的，其他折叠，保持与HTML初始状态一致或更清爽
      collapseState: {
        necessary: true,
        nonNecessary: false,
        usage: false,
        specifications: false,
        precautions: false,
      },
    };
  },
  methods: {
    handleBack() {
      // 返回上一页逻辑，可根据实际路由情况修改
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        // 如果没有历史记录，可以跳转到首页或其他指定页面
        this.$router.push("/");
      }
    },
    toggleCollapse(key) {
      this.collapseState[key] = !this.collapseState[key];
    },
  },
};
</script>

<style scoped>
.privacy-policy {
  min-height: 100vh;
  background-color: #ffffff; /* 修改为白色背景以匹配HTML */
  color: #333;
  font-size: 14px;
  line-height: 1.6;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

/* 头部样式 */
.policy-header {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  /* 如果不需要顶部标题栏，可以注释掉这部分或隐藏 */
  /* display: none; */
}

.back-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #333;
  margin-right: 16px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
}

.icon-arrow-left::before {
  content: "←";
  font-weight: bold;
  font-size: 22px;
}

.policy-title {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  flex: 1;
  text-align: center;
  color: #6785a0; /* 匹配HTML标题颜色 */
}

/* 内容区域样式 */
.policy-content {
  padding: 20px 30px 40px 30px;
  max-width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}

.policy-section {
  margin-bottom: 24px;
  /* 移除卡片式背景，采用纯文本流式布局以匹配HTML */
  background-color: transparent;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-top: 0;
  margin-bottom: 12px;
  padding-bottom: 0;
  border-bottom: none;
  line-height: 1.4;
}

/* 折叠区域样式 */
.collapsible-section {
  margin-bottom: 12px;
}

.subsection-title {
  font-size: 15px;
  font-weight: 500;
  color: #444444;
  margin: 8px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 8px 0;
  border-bottom: 1px solid #f5f5f5;
}

.collapsible-header {
  /* 继承 subsection-title 样式 */
}

.arrow-icon {
  font-size: 14px;
  color: #999999;
  transition: transform 0.3s ease;
  margin-left: 10px;
  display: inline-block;
}

.arrow-icon.up {
  transform: rotate(180deg);
}

.collapsible-content {
  padding-left: 0;
  margin-top: 8px;
  /* 简单的淡入动画效果可以通过CSS transition实现，这里主要控制显示隐藏 */
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-content {
  color: #666666;
  font-size: 14px;
  line-height: 1.6;
}

.section-content p {
  margin-bottom: 8px;
  text-align: justify;
}

/* 日期信息样式 */
.date-info {
  font-size: 13px;
  color: #999;
  margin-bottom: 12px;
  line-height: 1.5;
}

.date-info-footer {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

/* 列表与条目样式 */
.info-item,
.right-item {
  margin-bottom: 12px;
}

.info-label,
.right-label {
  font-weight: 600;
  color: #333333;
  margin-bottom: 4px;
  font-size: 14px;
  display: block;
}

.info-desc,
.right-desc {
  color: #666666;
  line-height: 1.6;
  font-size: 14px;
  text-align: justify;
  display: block;
}

.permission-list,
.rule-list {
  margin-top: 8px;
  padding-left: 0;
  list-style: none;
}

.permission-list li,
.rule-list li {
  margin-bottom: 6px;
  color: #666666;
  font-size: 14px;
  line-height: 1.6;
  position: relative;
  padding-left: 15px;
  text-align: justify;
}

.permission-list li::before,
.rule-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #999;
}

/* 联系信息 */
.contact-info {
  margin-top: 12px;
  color: #666666;
  font-size: 14px;
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 8px;
}

.phone-number {
  color: #007aff;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;
}

/* SDK 链接样式 */
.sdk-link {
  color: #007aff;
  text-decoration: underline;
  word-break: break-all;
}

/* 底部签署 */
.footer-signature {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  font-size: 13px;
  color: #999;
  text-align: center;
}

.bottom-space {
  height: 20px;
}

/* 辅助类 */
.mt-2 {
  margin-top: 8px;
}
.mt-4 {
  margin-top: 16px;
}
.mb-2 {
  margin-bottom: 8px;
}

/* 响应式调整 */
@media (max-width: 375px) {
  .section-title {
    font-size: 16px;
  }
  .subsection-title,
  .section-content,
  .info-desc,
  .rule-list li {
    font-size: 13px;
  }
  .policy-content {
    padding: 15px 20px 30px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue